<app-navbar-style-two></app-navbar-style-two>

<div class="privacy-policy-section">
  <div class="container">
    <div class="policy-header">
      <h1>Return Policy</h1>
      <p>
        We aim to ensure a smooth and satisfactory experience for all our customers.<br>
        However, due to the nature of tiles, we have the following return policy:
      </p>
    </div>

    <div class="policy-content">
      <div class="policy-item">
        <h4>1. Return Policy Details</h4>
        <ul>
          <li><strong>Returns Eligibility:</strong>
            <ul>
              <li>Returns are accepted only for products that are:</li>
              <li>– Damaged during transit.</li>
              <li>– Incorrect as per the confirmed order.</li>
            </ul>
          </li>

          <li><strong>Reporting Timeline:</strong>
            <ul>
              <li>Issues must be reported within 24 hours of delivery with proper photographic/video evidence.</li>
              <li>Returns will not be accepted for minor shade or size variations.</li>
            </ul>
          </li>

          <li><strong>Conditions:</strong>
            <ul>
              <li>Products must be unused and in original packaging.</li>
              <li>Return shipping (if applicable) must be arranged within 7 days.</li>
            </ul>
          </li>

          <li><strong>Non-Returnable Items:</strong>
            <ul>
              <li>Custom-cut tiles, clearance stock, and bulk order items (above 1000 sq.ft.) are non-returnable.</li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
